module.exports = __webpack_public_path__ + "img/xiazai2.9cfe97eb.png";